const ITEMS = ["Catch yourself", "Land more safely", "Get back up", "Get stronger and steadier"];

const Diamond = () => (
    <svg aria-hidden="true" viewBox="0 0 12 12" className="h-3 w-3 shrink-0">
        <rect x="2" y="2" width="8" height="8" rx="1.5" transform="rotate(45 6 6)" fill="#F59E0B" />
    </svg>
);

export default function Marquee({ items = ITEMS }) {
    return (
        <section aria-hidden="true" className="overflow-hidden border-y border-ink bg-ink py-4 text-cream">
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
                        {items.map((t) => (
                            <span
                                key={`${copy}-${t}`}
                                className="flex items-center gap-8 whitespace-nowrap px-8 font-display text-base font-bold uppercase tracking-[0.22em]"
                            >
                                {t}
                                <Diamond />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}